import React from 'react';
import { ExternalLink, Calendar, User } from 'lucide-react';

const PipelineCardDetailed = ({ opportunity, stageColor, onClick }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div
      onClick={() => onClick && onClick(opportunity)}
      className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
      style={{ borderLeftColor: stageColor, borderLeftWidth: '3px' }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 pr-2">
          <h4 className="text-base font-semibold text-[#2B2D42] mb-1">
            {opportunity.name}
          </h4>
          {opportunity.description && (
            <p className="text-xs text-[#6C757D] line-clamp-2">
              {opportunity.description}
            </p>
          )}
        </div>
        <ExternalLink className="h-4 w-4 text-[#6C757D] flex-shrink-0" />
      </div>

      <div className="flex items-center justify-between mb-3">
        <span className="text-xl font-bold" style={{ color: stageColor }}>
          {formatCurrency(opportunity.value)}
        </span>
        <div className="flex items-center space-x-2">
          <span className="text-xs text-[#6C757D]">Probability:</span>
          <span className="text-sm font-semibold text-[#2B2D42]">
            {opportunity.probability}%
          </span>
        </div>
      </div>

      <div className="space-y-2 mb-3">
        {opportunity.client_id && (
          <div className="flex items-center text-xs text-[#6C757D]">
            <User className="h-3 w-3 mr-1" />
            <span>Client: {opportunity.client_id}</span>
          </div>
        )}
        
        {opportunity.expected_close_date && (
          <div className="flex items-center text-xs text-[#6C757D]">
            <Calendar className="h-3 w-3 mr-1" />
            <span>Expected Close: {formatDate(opportunity.expected_close_date)}</span>
          </div>
        )}
      </div>

      {opportunity.tags && opportunity.tags.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {opportunity.tags.map((tag, index) => (
            <span
              key={index}
              className="px-2 py-0.5 text-xs rounded-full"
              style={{
                backgroundColor: `${stageColor}15`,
                color: stageColor
              }}
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default PipelineCardDetailed;
